@if(tasks$ | async; as tasks) {
  <div class="flex flex-col w-full pt-4">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
          <mat-tab>
            <ng-template mat-tab-label>
              <div matBadgeColor="warn" [matBadge]="solicitudes.total" matBadgeOverlap="false">Solicitudes</div>
            </ng-template>
              <ng-template matTabContent>
                <card-task [tasks]="solicitudes" [tipoPaginacion]="this.tipoSolicitudes" class="w-full"></card-task>
              </ng-template>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <div matBadgeColor="warn" [matBadge]="gestiones.total"  matBadgeOverlap="false">Gestiones</div>
              </ng-template>
              <ng-template matTabContent>
                <card-task [tasks]="gestiones"  [tipoPaginacion]="this.tipoGestiones" class="w-full"></card-task>
              </ng-template>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <div matBadgeColor="warn" [matBadge]="tasks.bienesCulturales.total"  matBadgeOverlap="false">Bienes Culturales</div>
              </ng-template>
              <ng-template matTabContent>
                <card-bienes-culturales [ficha]="tasks.bienesCulturales"></card-bienes-culturales>
              </ng-template>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <div matBadgeColor="warn" [matBadge]="tasks.coleccionistas.total"  matBadgeOverlap="false">Coleccionistas</div>
              </ng-template>
              <ng-template matTabContent>
                <card-coleccionista [coleccionistas]="tasks.coleccionistas"></card-coleccionista>
              </ng-template>
            </mat-tab>
            <!--<mat-tab label="Uploads">
              <ng-template matTabContent>
                Content 1 
              </ng-template>
            </mat-tab>-->
      </mat-tab-group>
  </div>
}
  